export const getLineChartOptions = (chart: ChartBlockAttributes) => {
    return {
        showLabels: chart.display.showLabels ?? true,
        showValues: chart.display.showValues ?? true,
    }
}
